export default "__VITE_ASSET__UEFE5tR5__"